import { Component } from '@angular/core';
import { UnidadeMedida } from '../../../../types/UnidadeMedida.type';
import { UnidademedidaService } from '../../../../services/unidademedida.service';
import { ToastService } from '../../../../services/toast.service';

@Component({
  selector: 'app-unidadesmedidas',
  templateUrl: './unidadesmedidas.component.html',
  styleUrl: './unidadesmedidas.component.css'
})
export class UnidadesmedidasComponent {

  unidades: UnidadeMedida[] = []

  loading: boolean = false;
  loadingSincronizar: boolean = false;

  constructor(private unidadesService: UnidademedidaService, private toastService: ToastService) {
    this.getAll()
  }

  getAll() {

    this.loading = true;

    this.unidadesService.getAll().subscribe({
      next: (data) => { this.unidades = data; this.loading = false; },
      error: (value) => { console.error(value); this.loading = false }
    })
  }

  exportar() {

    this.loadingSincronizar = true;


    this.unidadesService
      .exportar()
      .subscribe({
        next: (value) => {
          const url = window.URL.createObjectURL(value);
          const a = document.createElement('a')
          a.href = url
          a.download = 'unidademedidas.xlsx'
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        },
        error: (error) => {
          this.toastService.erro("Exportar", 'Erro ao exportar:' + error.error);
          this.loadingSincronizar = false;
        },
        complete: () => {
          this.loadingSincronizar = false;
        },

      });
  }

}
